import React, { useCallback, useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { ReminderDialog, ReminderRow, toggleReminder } from "@/components/Reminder";
import { api } from "@/lib/api";
import { VET_LINE } from "@/lib/constants";

export default function Reminders() {
  const [items, setItems] = useState([]);
  const [pets, setPets] = useState([]);
  const [open, setOpen] = useState(false);
  const load = useCallback(async () => {
    const [r, p] = await Promise.all([api.get("/reminders"), api.get("/pets")]);
    setItems(r.data); setPets(p.data);
  }, []);
  useEffect(() => { load(); }, [load]);
  const petMap = Object.fromEntries(pets.map((p) => [p.id, p]));
  const open_ = items.filter((r) => !r.done);
  const done = items.filter((r) => r.done);
  const row = (r) => <ReminderRow key={r.id} r={r} pet={petMap[r.pet_id]} onToggle={async (x) => { await toggleReminder(x); load(); }} onDelete={async (x) => { await api.delete(`/reminders/${x.id}`); load(); }} />;
  return (
    <div data-testid="reminders-page">
      <div className="flex items-center justify-between mb-2">
        <h1 className="font-heading text-4xl font-extrabold">Coming up</h1>
        <button className="pl-btn-primary !min-h-[44px]" onClick={() => setOpen(true)} disabled={!pets.length} data-testid="reminders-add-btn"><Plus className="h-4 w-4" />Add</button>
      </div>
      <p className="text-sm text-slate-500 mb-5">Vaccines, preventives and vet visits. We email you 7 days before and on the day.</p>
      <div className="space-y-3">{open_.map(row)}</div>
      {open_.length === 0 && <p className="text-slate-500" data-testid="reminders-empty">Nothing due. Upload vet paperwork on a pet's Records tab to fill this in automatically.</p>}
      {done.length > 0 && <><h2 className="font-heading text-lg font-semibold mt-8 mb-3 text-slate-500">Done</h2><div className="space-y-3">{done.map(row)}</div></>}
      <ReminderDialog open={open} onOpenChange={setOpen} pets={pets} onSaved={load} />
      <p className="text-[11px] text-slate-400 mt-8">{VET_LINE}</p>
    </div>
  );
}
